// Exact match with backend ChatSharingStatus enum
export const CHAT_SHARING_STATUS = {
  NOT_SHARED: 'NOT_SHARED',
  SHARED: 'SHARED',
  SHARED_ANONYMOUSLY: 'SHARED_ANONYMOUSLY'
};

// Human-readable labels for UI
export const SHARING_STATUS_LABELS = {
  [CHAT_SHARING_STATUS.NOT_SHARED]: 'Not Posted',
  [CHAT_SHARING_STATUS.SHARED]: 'Posted',
  [CHAT_SHARING_STATUS.SHARED_ANONYMOUSLY]: 'Posted Anonymously'
};

// Descriptions for each option
export const SHARING_STATUS_DESCRIPTIONS = {
  [CHAT_SHARING_STATUS.NOT_SHARED]: 'Keep this conversation private',
  [CHAT_SHARING_STATUS.SHARED]: 'Create a public post with your name and chat history',
  [CHAT_SHARING_STATUS.SHARED_ANONYMOUSLY]: 'Create a public post without your name or chat history',
};

// Message mapping for backend communication
export const SHARE_MESSAGES = {
  [CHAT_SHARING_STATUS.SHARED]: 'Create a public post',
  [CHAT_SHARING_STATUS.SHARED_ANONYMOUSLY]: 'Create a public post anonymously',
  [CHAT_SHARING_STATUS.NOT_SHARED]: 'Remove post',
};

// ============================================
// App Visibility (direct toggle, no agent involvement)
// ============================================
export const APP_VISIBILITY = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
};

export const APP_VISIBILITY_LABELS = {
  [APP_VISIBILITY.PRIVATE]: 'Private',
  [APP_VISIBILITY.PUBLIC]: 'Public'
};

export const APP_VISIBILITY_DESCRIPTIONS = {
  [APP_VISIBILITY.PRIVATE]: 'Only you can access this app',
  [APP_VISIBILITY.PUBLIC]: 'Anyone with the link can access this app'
};

// ============================================
// Community Showcase (rebranded from "sharing/posting")
// ============================================
export const SHOWCASE_STATUS = {
  NONE: 'NONE',
  SHOWCASED: 'SHOWCASED',
  SHOWCASED_ANONYMOUSLY: 'SHOWCASED_ANONYMOUSLY'
};

export const SHOWCASE_STATUS_LABELS = {
  [SHOWCASE_STATUS.NONE]: 'Not showcased',
  [SHOWCASE_STATUS.SHOWCASED]: 'Showcased with your name',
  [SHOWCASE_STATUS.SHOWCASED_ANONYMOUSLY]: 'Showcased anonymously'
};

export const SHOWCASE_STATUS_DESCRIPTIONS = {
  [SHOWCASE_STATUS.NONE]: 'Your app is not on the community feed',
  [SHOWCASE_STATUS.SHOWCASED]: 'Featured on CellCog\'s community feed with your name',
  [SHOWCASE_STATUS.SHOWCASED_ANONYMOUSLY]: 'Featured on CellCog\'s community feed without your name'
};
